import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to Sweet Delight",
    title: "Step into a World of Sweet Delights",
    content: "Indulge in a symphony of flavors with our artisanal baked goods, where every bite is a delightful journey into sweetness.",
    buttonText: "Our Menu",
    buttonLink: "Menu",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to Sweet Delight",
    title: "Savor the Magic of Freshly Baked Happiness",
    content: "Experience the warmth and joy of our oven-fresh creations, crafted with love to fill your days with delicious memories.",
    buttonText: "Our Menu",
    buttonLink: "Menu",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to Sweet Delight",
    title: "Your Journey to Irresistible Treats Begins Here",
    content: "Embark on a delectable adventure through our bakery, where irresistible treats and unforgettable moments await you.",
    buttonText: "Our Menu",
    buttonLink: "Menu",
  },
];

export default home;